import { createApi } from "@reduxjs/toolkit/query/react";

import type {
  ICreateLeaveEntitlementRequest,
  IGetLeaveEntitlementByIdRequest,
  IUpdateLeaveEntitlementRequest,
  IUpdateLeaveEntitlementResponse,
  TCreateLeaveEntitlementResponse,
  TGetLeaveEntitlementByIdResponse,
  TGetLeaveEntitlementsListingRequest,
  TGetLeaveEntitlementsListingResponse,
} from "@/types/(company)/leaveEntitlements.interface";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";

export const companyLeaveEntitlementsApi = createApi({
  reducerPath: "companyLeaveEntitlementsApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["LeaveEntitlementsSettings"],
  endpoints: (builder) => ({
    getAllLeaveEntitlements: builder.query<
      TGetLeaveEntitlementsListingResponse,
      TGetLeaveEntitlementsListingRequest
    >({
      query: () => ({
        url: "/company/settings/leave-entitlements",
        method: "GET",
      }),
      providesTags: ["LeaveEntitlementsSettings"],
    }),
    createLeaveEntitlement: builder.mutation<
      TCreateLeaveEntitlementResponse,
      ICreateLeaveEntitlementRequest
    >({
      query: (data) => ({
        url: "/company/settings/leave-entitlements",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["LeaveEntitlementsSettings"],
    }),
    getLeaveEntitlementById: builder.query<
      TGetLeaveEntitlementByIdResponse,
      IGetLeaveEntitlementByIdRequest
    >({
      query: ({ id }) => ({
        url: "/company/settings/leave-entitlements" + `/${id}`,
        method: "GET",
      }),
      providesTags: ["LeaveEntitlementsSettings"],
    }),
    updateLeaveEntitlement: builder.mutation<
      IUpdateLeaveEntitlementResponse,
      IUpdateLeaveEntitlementRequest
    >({
      query: (data) => ({
        url: "/company/settings/leave-entitlements" + `/${data.id}`,
        method: "PATCH",
        body: data.data,
      }),
      invalidatesTags: ["LeaveEntitlementsSettings"],
    }),
    deleteLeaveEntitlement: builder.mutation<
      { success: boolean; message: string },
      number
    >({
      query: (id) => ({
        url: "/company/settings/leave-entitlements" + `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["LeaveEntitlementsSettings"],
    }),
  }),
});

export const {
  useGetAllLeaveEntitlementsQuery,
  useCreateLeaveEntitlementMutation,
  useGetLeaveEntitlementByIdQuery,
  useUpdateLeaveEntitlementMutation,
  useDeleteLeaveEntitlementMutation,
} = companyLeaveEntitlementsApi;
